import _ from 'lodash';
import { FC } from 'react';
import { Box } from '@wix/design-system';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import ShowMoreText from '@components/ShowMoreText';
import IndustryAndLanguage from '@components/Template/IndustryAndLanguage';
import Features from '@components/Template/Features';
import { MAX_CHARACTER_LIMIT } from '@components/Template/constant';

const AboutTab: FC = () => {
  const {
    template: { description, apps },
  } = useTemplateContext();
  return (
    <Box direction="vertical" gap="6px" marginBottom="18px" marginTop="24px">
      <>
        <ShowMoreText
          textSize="small"
          maxChars={MAX_CHARACTER_LIMIT}
          originalText={description}
        />
        <IndustryAndLanguage direction="vertical" textSize="small" />
        <Box paddingTop="18px">
          {!_.isEmpty(apps) && <Features isMobileView={true} />}
        </Box>
      </>
    </Box>
  );
};

export default AboutTab;
